import { useTenantStore } from "@/stores/tenantStore";

export const useTenantId = () => useTenantStore((s) => s.id);
